import React, { useEffect, useState } from 'react';
import { LessonPlanFolder } from './lesson-plan-folder';
import { FinderSubfolder, FinderTreeItem } from '@/components/finder';

export function LessonPlanTreeItem(props) {
  const { setCurrentFolder, folder, onClick, isOpenFolder = null, idOpenedSubFolder, setIdOpenedSubFolder, setIdOpenedFolder } = props;

  const [isExpanded, setIsExpanded] = useState(null);
  const [uniqueShifts, setUniqueShifts] = useState([]);

  useEffect(() => {
    if (folder?.['class-plans']) {
      const uniqueShifts = folder['class-plans']
        .reduce((result, item) => {
          if (!result.some(i => i.shift === item.shift)) {
            result.push(item);
          }
          return result;
        }, [])
        .map(item => item.shift);

      setUniqueShifts(uniqueShifts);
    }
  }, [folder]);

  const handleClickSubFolder = shift => {
    const filteredFolders = folder?.['class-plans'].filter(item => item.shift === shift);
    const subId = `${shift}-${folder.id}`;

    setIdOpenedSubFolder(subId);
    setCurrentFolder(filteredFolders);
    setIdOpenedFolder(null);
  };

  return (
    <FinderTreeItem>
      <LessonPlanFolder
        name={`${folder.year ? `${folder.year} - ` : ''} ${folder.title} `}
        subFolders={folder?.['class-plans']}
        isExpanded={isExpanded}
        folderId={folder.id}
        setIsExpanded={setIsExpanded}
        setCurrentFolder={setCurrentFolder}
        setIdOpenedSubFolder={setIdOpenedSubFolder}
        isOpenFolder={isOpenFolder}
        onClick={onClick}
      />

      {uniqueShifts?.map(item => (
        <FinderSubfolder
          key={item}
          isExpanded={isExpanded}
          className="animate-fade-in"
        >
          <LessonPlanFolder
            name={item}
            subFolders={[]}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            isSubFolder={true}
            isOpenFolder={idOpenedSubFolder === `${item}-${folder.id}`}
            onClick={() => handleClickSubFolder(item)}
          />
        </FinderSubfolder>
      ))}
    </FinderTreeItem>
  );
}
